// eslint-disable-next-line no-restricted-imports
import {
  DirectoryGetRecordsDocument,
  useDirectoryCreateRecordMutation,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { useNotifyMessages } from 'api/helpers/useNotifyMessages';
import { DirectoryRecordFieldParam } from 'api/types/params';

export interface DirectoryCreateRecordParam {
  schemaId: string;
  fields: DirectoryRecordFieldParam[];
}

export const useDirectoryCreateRecord = () => {
  const [handleCreateRecord, { loading, error: apolloError }] =
    useDirectoryCreateRecordMutation({
      awaitRefetchQueries: true,
      refetchQueries: [DirectoryGetRecordsDocument],
    });

  const error = useError(apolloError);

  const notifyMessage = useNotifyMessages();

  const createRecord = async (input: DirectoryCreateRecordParam) => {
    const res = await handleCreateRecord({
      variables: {
        input: {
          schemaId: input.schemaId,
          fields: input.fields.map((field) => ({
            name: field.name,
            referenceRecordId: field.referenceRecordId,
            value: field.value,
          })),
        },
      },
    });

    notifyMessage(res.data?.create?.messages);

    return res;
  };

  return { createRecord, loading, error };
};
